import { apiLambda } from './apiLambda';

async function addBatchCaptureCard(
  batchCode: number,
  params: { encryptedCaptureCardData: string },
) {
  const { data } = await apiLambda.post(`batch/capture/${batchCode}`, params);
  return data;
}

export async function creditCardPayment(batchCode:number, dataEncrypted: string) {
  try {

    if (!batchCode) {
      console.error(`creditCardPayment ~ There's no valid BatchCode to add capture card`);
      throw new Error(`Não há código de Lote válido.`);
    }
    
    if (!dataEncrypted) {
      console.error("creditCardPayment ~ Invalid EncryptedData:", dataEncrypted)
      throw new Error('Não dados encriptados válidos.');
    }
    const payment = await addBatchCaptureCard(batchCode, {encryptedCaptureCardData: dataEncrypted});

    return payment.data.data;
  } catch (err: any) {
    console.log('PaymentCard - ===> ', err?.response?.status ?? err?.message);
    if (err.response?.data?.warning) {
      return { sucesso: false, warning: err.response.data.warning };
    }
    const lambdaMessage =
      err?.response?.data?.message || err?.response?.data?.data?.message;

    const paymentLimit = err?.response?.data?.paymentLimit || undefined;

    const response = {
      codigoPagamento: null,
      mensagem: lambdaMessage,
      sucesso: false,
      data: err.response?.data?.data,
      paymentLimit,
    };
    return response;
  }
}
